import React, { useEffect, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import FilledInput from "@material-ui/core/FilledInput";

import CachedIcon from "@material-ui/icons/Cached";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import { useTimer } from "../../../Hooks/useTimer";
import ErrorIcon from "@material-ui/icons/Error";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

function AuthPopup(props) {
  const [otpInput, setOtpInput] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [resendAllowed, setResendAllowed] = useState(false);
  const [otpApproved, setOtpApproved] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  useEffect(() => {
    sendOTP();
  }, []);

  const handleOTPInput = (input) => {
    setOtpApproved(false);
    setOtpInput(input);
    setOtpError(false);
  };

  const { time, start, reset } = useTimer({
    initialTime: 60,
    endTime: 0,
    timerType: "DECREMENTAL",
    autostart: true,
    onTimeOver: () => {
      setResendAllowed(true);
    },
  });

  const handleContinueClick = (e) => {
    e.preventDefault();

    if (otpInput.length == 0) return;
    if (otpInput.length !== 6) {
      setOtpError("OTP must be exactly 6 characters");
      return;
    }
    setOtpError(false);
    setOtpLoading(true);

    afterLoginApiAxios
      .post(
        "/doctor/verify-auth",
        {
          otp: otpInput,
        },
        {
          headers: {
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        setOtpLoading(false);
        if (response.data.statusCode == 200) {
          props.success();
          props.close();
        } else {
          setOtpError("Incorrect OTP entered. Please try again.");
        }
      })
      .catch((err) => C2CConsole.error(err));
  };

  const getOTPAdornment = () => {
    if (otpLoading)
      return <CachedIcon className="rotating" style={{ color: "#4AC9E7" }} />;
    if (otpApproved) return <CheckCircleIcon style={{ color: "#10A74A" }} />;
    if (otpError) return <ErrorIcon style={{ color: "#e84444" }} />;
    return null;
  };

  return (
    <div
      className="container h-100  d-flex align-items-center justify-content-center flex-column"
      style={{ position: "relative" }}
    >
      <div className="w-100 mt-2">
        <form
          className="d-flex flex-column align-items-center justify-content-center"
          onSubmit={(e) => {
            handleContinueClick(e);
          }}
        >
          <FormControl
            hiddenLabel="true"
            size="small"
            margin="dense"
            fullWidth="true"
          >
            <FilledInput
              id="OTP-input"
              aria-describedby="my-helper-text"
              required
              aria-required
              placeholder="Enter OTP"
              aria-label="otp-input"
              autoFocus={true}
              inputProps={{
                autoComplete: "off",
                inputMode: "numeric",
              }}
              disableUnderline="true"
              value={otpInput}
              endAdornment={getOTPAdornment()}
              onChange={(e) => {
                handleOTPInput(e.target.value);
              }}
            />
          </FormControl>
          <div className="row justify-content-between w-100">
            <div className="col-6 p-0">
              {resendAllowed ? (
                <div className="align-self-start text-muted">OTP expired</div>
              ) : (
                <div className="align-self-start text-muted">
                  {time} seconds left to expire
                </div>
              )}
            </div>
            <div className="col-6 p-0 d-flex justify-content-end align-items-start">
              <div
                className={`cursor-pointer ${
                  !resendAllowed ? "text-muted pointer-disabled" : "textLink"
                }`}
                style={{ textAlign: "right" }}
                onClick={(e) => {
                  e.preventDefault();
                  if (!resendAllowed) return;
                  setOtpError(false);
                  sendOTP();
                  reset();
                  start();
                  setResendAllowed(false);
                }}
              >
                Resend OTP
              </div>
            </div>
          </div>
          <div className="input-error text-center mt-1 w-100">
            {otpError ? otpError : ""}
          </div>
          <button
            className="btn primary-cta-button rounded-pill mt-4 align-self-center py-2 px-4"
            disabled={resendAllowed}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );

  function sendOTP() {
    afterLoginApiAxios.post(
      "doctor/two-factor-auth",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      }
    );
  }
}

export default AuthPopup;
